<template>
  <div class="col-12 col-md-12 col-lg-8">
    <div class="tit text-center">
      <p>Quanto sua empresa lucra por mês?</p>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">
        <form @submit="onSubmit">
          <div class="form-group text-left">
            <label class="float-left">Lucro Mensal</label>
            <input class="form-control form-control-lg" v-focus v-model="lucroMensal" type="text" required v-mask="'money'" placeholder="R$" />
          </div>
          <div class="text-center fixedOptions">
             <button :disabled="lucroValido" class="btn btn-lg btn-primary">Próximo<img src="../../assets/images/angle-right.svg"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Masker from '@/utils/masker'

export default {
  data(){
    const lucroMensal = this.solicitacao.Empresa.LucroMensal
    return {
      lucroMensal: lucroMensal ? lucroMensal.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2}) : null
    }
  },
  computed: {
    lucroValido: function() { return parseFloat(this.lucroMensal) <= 0 }
  },
  props: {
    solicitacao: {required: true, type: Object},
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()

      const newData = {
        Empresa: {
          LucroMensal: Masker.formatReal(this.lucroMensal)
        }
      }
      this.$emit('on-submit', newData)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/LucroMensalStep.vue